// Applies to Event Detail and Article Detail pages
const content = document.querySelector(".detail-content");
const image = document.querySelector(".detail-image");
const data = document.querySelector(".detail-data");

const resetDesktop = () => {
	data.prepend(image);
}

const resetMobile = () => {
	content.appendChild(image);
}

blue.ready('detailContent', ".detail-content", function() {
	//set mobile image position if page loads on mobile viewport
	if (!blue.prop.media.default.matches) {
		resetMobile();
	}

	//reset image position on viewport size change
	blue.prop.media.default.addListener(e => {
		if (e.matches) {
			resetDesktop();
		}
		else {
			resetMobile();
		}
	});
});